interface FormInputProps {
  label: string;
  type?: string;
  name: string;
  placeholder?: string;
  register: any;
  error?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  value?: string;
  disabled?: boolean;
  className?: string;
}

export const FormInput = ({
  label,
  type,
  name,
  placeholder,
  register,
  error,
  value,
  onChange,
  disabled,
  className,
}: FormInputProps) => {
  return (
    <div className={"flex flex-col w-full"}>
      <label className="text-sm text-gray-500">{label}</label>
      <input
        className={`border p-2 outline-none bg-gray-100 rounded-lg  ${className}`}
        {...register(name)}
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        disabled={disabled}
      />
      {error && <p className="text-rose-500 text-sm mt-1">{error}</p>}
    </div>
  );
};
